const localizers = {
  'loading.msg': () => `Načítání...`,
  'logon.message.msg': () => `Je požadována autentizace. Zadejte platní ID uživatele a heslo.`,
  'logon.button.msg': () => `Přihlášení...`,
  'SASServer.logonError.msg': () => `K serveru se nelze přihlásit.`,
  'SASServer.genericError.msg': () => `Server je nedosažitelný.`,
}
export default localizers;
